// React Query обвивката на „Продадено без наличност" — подсказката при запис на
// доставка. По една заявка на склад (доставката може да има редове в няколко);
// ключът е под ["inventory", "stock", …], затова всяка складова мутация (която
// чисти наличностите) го опреснява без нов ред в `invalidateAll`.
// В локален режим (каса без интернет) складът е извън обхвата → заявките мълчат.
import { useQueries } from "@tanstack/react-query";
import { getNegativeStock, type NegativeStock, type NegativeStockParams } from "../api/inventoryNegativeStock";
import { useIsEdgeLocal } from "./useEdgeMode";

export type NegativeStockByWarehouse = { warehouseId: number; items: NegativeStock[] };

export const useNegativeStock = (paramsList: NegativeStockParams[]): NegativeStockByWarehouse[] => {
  const isLocal = useIsEdgeLocal();
  return useQueries({
    queries: paramsList.map((params) => ({
      queryKey: ["inventory", "stock", "negative", params],
      queryFn: () => getNegativeStock(params),
      enabled: params.productIds.length > 0 && !isLocal,
      // смяна на датата държи старата подсказка, докато дойде новата
      placeholderData: (previous: NegativeStock[] | undefined) => previous,
    })),
    combine: (results) =>
      results.map((result, index) => ({
        warehouseId: paramsList[index].warehouseId,
        items: result.data ?? [],
      })),
  });
};
